<header class="top-header">
  <div class="d-flex align-items-center gap-3">
    <button class="mobile-menu-btn">
      <i class="bi bi-list"></i>
    </button>
    <h5>{{ pageTitle() }}</h5>
  </div>
  <div class="user-info">
    <div class="user-avatar">{{ getUserInitial() }}</div>
    <div>
      <div class="fw-bold">{{ user()?.name || user()?.phone || 'Admin' }}</div>
      <small class="text-muted">{{ user()?.primaryPersona || 'Administrator' }}</small>
    </div>
    <button class="btn btn-sm btn-outline-danger" (click)="logout()">
      <i class="bi bi-box-arrow-right"></i> Logout
    </button>
  </div>
</header>
